<template>
  <div class="d-inline-block">
    <w-button class="btn-light btn-filters mr-2 mb-1" text="Filtruj" @click="openModal()" />

    <w-button
      v-for="(filter, index) in filtersApplied"
      :key="'filter_' + index"
      class="btn-light btn-filters mr-2 mb-1"
      @click="clearFilter(filter)"
    >
      <i class="fas fa-times mr-2" />

      <span>{{ filterText(filter) }}</span>
    </w-button>

    <w-button v-if="anyFilterApplied" class="btn-danger" icon="fas fa-times" text="Wyczyść" @click="clearAll" />

    <schema-form-filters-modal
      title="Filtry"
      :show="showModal"
      :available-filters="availableFilters"
      :entity-id="entityId"
      @close="closeModal"
      @filter="updateAndFilter"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SchemaFormFiltersModal from '@/components/modals/SchemaFormFiltersModal';
import { EntityType } from '@/enums/entityType.enum';
import { Storage } from '@/enums/storage.enum';
import { getFilters } from '@/utils/document';
import { PublicSettings } from '../../../enums/publicSettings.enum';

// @vuese
// Filtry
// WAŻNE: Schema filtrów nie może używać refów!
// @group Table
export default {
  components: { SchemaFormFiltersModal },

  props: {
    // Lista dostępnych filtrów
    // WAŻNE: Schema filtrów nie może używać refów!
    availableFilters: { type: Array, required: true },

    // Encja doklejana do nazwy pola w localStorage
    entityId: { type: [String, Number], required: false }
  },

  data() {
    return {
      filters: getFilters(this.entityId),
      showModal: false
    };
  },

  computed: {
    ...mapState({
      schema: state => state.schema.data && JSON.parse(state.schema.data.schema)
    }),

    anyFilterApplied() {
      return !!this.filters && !!Object.values(this.filters).filter(value => value !== undefined).length;
    },

    filtersApplied() {
      return this.availableFilters.filter(filter => this.isFilterApplied(filter));
    }
  },

  methods: {
    // @vuese
    // Czy filtr jest aktywny
    isFilterApplied(filter) {
      return !!this.filters[filter.field];
    },

    // @vuese
    // Tekst filtru
    filterText(filter) {
      if (!this.isFilterApplied(filter)) {
        return filter.name;
      }

      const query = this.filters[filter.field];
      if (query.$regex) {
        return query.$regex;
      }

      if (query.$eq !== null && query.$eq !== undefined && Array.isArray(filter.options)) {
        return filter.options.find(option => option.value === query.$eq).text;
      }

      if (query.$in && filter.options) {
        return query.$in.map(value => filter.options.find(option => option.value === value).text).join(', ');
      }

      if (query.$in) {
        return query.$in.join(', ');
      }

      if (query._street) {
        return [query._street, [query.nr, query.localNr].filter(Boolean).join('/')].filter(Boolean).join(' ');
      }

      for (const field of ['_city', '_gmi', '_pow', '_woj']) {
        if (query[field]) {
          return query[field];
        }
      }

      const values = [];
      if (query.$gte) {
        values.push(`od ${query.$gte}zł`);
      }
      if (query.$lte) {
        values.push(`do ${query.$lte}zł`);
      }
      if (values.length) {
        return values.join(' ').trim();
      }

      return filter.name;
    },

    // @vuese
    // Otwiera modal edycji filtru
    openModal() {
      this.$store.commit('setting/saveByCode', { code: PublicSettings.SUBMIT_BUTTON_TEXT, value: 'Pokaż wyniki' });
      this.showModal = true;
    },

    // @vuese
    // Zamyka modal edycji filtru
    closeModal() {
      this.showModal = false;
    },

    // @vuese
    // Aktualizacja filtrów
    updateAndFilter(filters) {
      this.filters = filters;
      this.$emit('filter');
    },

    // @vuese
    // Czyści filtr
    clearFilter(filter) {
      this.filters = { ...this.filters, [filter.field]: undefined };
      this.updateFilters();
    },

    // @vuese
    // Czyści wszystkie filtry
    clearAll() {
      this.filters = {};
      this.updateFilters();
    },

    // @vuese
    // Zapisuje filtry do storage i emituje event
    updateFilters() {
      localStorage.setItem(Storage.FILTERS + (this.entityId || ''), JSON.stringify(this.filters));
      this.$emit('filter');
    }
  }
};
</script>

<style>
.btn-filters i.fa-times {
  color: red;
  z-index: 100;
}

.btn-filters {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
